import * as yup from 'yup';
import { txtPay as TEXT } from 'locales/en';

export const FIELD_NAMES = {
  channel: 'channel',
  name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  phone_number: 'phone_number',
  phone_country: 'phone_country',
  email_content: 'email_content',
  sms_content: 'sms_content',
};
export const defaultValues = {
  [FIELD_NAMES.channel]: 'email',
  [FIELD_NAMES.name]: '',
  [FIELD_NAMES.last_name]: '',
  [FIELD_NAMES.email]: '',
  [FIELD_NAMES.phone_number]: '',
};

const schema = yup.object().shape({
  [FIELD_NAMES.email]: yup.string().when(FIELD_NAMES.channel, {
    is: (val) => val === 'email',
    then: yup
      .string()
      .email(TEXT.errors.email.invalid)
      .required(TEXT.errors.email.required),
  }),
  [FIELD_NAMES.phone_number]: yup.string().when(FIELD_NAMES.channel, {
    is: (val) => val === 'sms',
    then: yup
      .string()
      .phoneNumber(TEXT.errors.phone_number.invalid)
      .required(TEXT.errors.phone_number.required),
  }),
  [FIELD_NAMES.email_content]: yup.string().when(FIELD_NAMES.channel, {
    is: (val) => val === 'email',
    then: yup.string().required(TEXT.errors.content.required),
  }),
  [FIELD_NAMES.sms_content]: yup.string().when(FIELD_NAMES.channel, {
    is: (val) => val === 'sms',
    then: yup.string().required('sms req'),
  }),
});

export default schema;
